import React from 'react'
import Header from '../../Header/Header'
import Revenue_main_third from './Revenue_main_third'

const RevenueThirdBody = () => {
  return (
    <div>
        <Header title="Revenue Third" />
        <Revenue_main_third />
    </div>
  )
}

export default RevenueThirdBody
